import { QUERY_KEYS } from "@/common/query-keys";
import { checkoutConsumable } from "@/lib/snipeit/consumables";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useLocation } from "wouter";

/**
 * Full checkout with navigation — used by the checkout-consumable view.
 */
export function useCheckoutConsumable() {
  const queryClient = useQueryClient();
  const [, navigate] = useLocation();

  return useMutation({
    mutationFn: ({ consumableId, newQty }: { consumableId: number; newQty: number }) =>
      checkoutConsumable(consumableId, newQty),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.consumablesPage] });
      navigate("/consumables");
    },
  });
}

/**
 * Quick "-1" checkout without navigation — used by the consumables table.
 */
export function useQuickCheckoutConsumable() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ consumableId, currentQty }: { consumableId: number; currentQty: number }) =>
      checkoutConsumable(consumableId, currentQty - 1),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.consumablesPage] }),
  });
}
